import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useSubscription } from '../SubscriptionContext';
import './PitchContainer.css';

const PitchContainer = () => {
  const { user, signInWithGoogle } = useAuth();
  const { canGenerateQuestions } = useSubscription();
  const navigate = useNavigate();

  // Function to navigate to pricing section
  const navigateToPricing = () => {
    navigate('/');
    setTimeout(() => {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleGenerateQuestions = () => {
    if (user) {
      // Check if authenticated user can generate questions
      if (canGenerateQuestions()) {
        navigate('/dashboard');
      } else {
        // User has reached their limit, redirect to pricing
        navigateToPricing();
      }
    } else {
      signInWithGoogle();
    }
  };
    
  return (
    <div className="main-section" id="main-content">
      <div className="rating-badge">
            <img src="rating.png" alt="rating" />
      </div>
      <h2 className="trusted-text">Join 10,000+ Engineers at Boeing, Tesla, Joby Aviation<br className="mobile-break" /> and many more.</h2>
      <h1>Land Your Dream Job with <br/><span className="highlights">AI Interview Prep</span> + <span className="highlights">ATS Resumes</span></h1>
      <p>Tired of generic interview prep that ignores your engineering discipline? We built this exclusively for Mechanical, Aerospace, Civil, Manufacturing & all Non-IT Engineers. Beat ATS, ace HR, crush technical interviews, all from one job link.</p>
      <button onClick={handleGenerateQuestions} className='button'>Ace My Next Offer Now</button>
      <div className="video-placeholder" id="video-section">
        <video
          src="OriginalDemo.mp4"
          loop
          autoPlay
          muted
          playsInline
          preload="metadata"
          className="intro-video"
        />
      </div>
    </div>
  );
};

export default PitchContainer;